export default "/assets/provider-badge-vert.v1.svg";